<template>
  <label
    class="toggle-switch small"
    style="margin-top: 10px;vertical-align: bottom;"
    v-if="content && content.contentvalue != undefined"
  >
    <input type="checkbox" :checked="content.contentvalue" @change="onSwitch()" />
    <span class="toggle-slider lever round"></span>
  </label>
</template>

<script>
import axios from 'axios'
import config from '@/config'
import api from '@/api'

export default {
  props: ['value'],
  data: function() {
    return {
      content: this.value
    }
  },
  methods: {
    onSwitch: function() {
      let vm = this
      vm.content.contentvalue = !vm.content.contentvalue

      api.updateConfig(vm.content, function(error, response) {
        if (error) {
          console.error(error)
          return
        }
      })
    }
  },
  watch: {
    value: function() {
      this.content = this.value
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/setting/input-no-label/InputBooleanNoLabel.vue